"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.icon_resources = void 0;
// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)
exports.icon_resources = {
    en: {
        translation: {
            'import': { 'import': 'Imported icon' },
            agricol: {
                'agricol': 'agricol',
                'pack-of-cereal': 'pack-of-cereal',
                'apple': 'apple',
                'apple-2': 'apple-2',
                'banana': 'banana',
                'banana-2': 'banana-2',
                'berry': 'berry',
                'berry-2': 'berry-2',
                'pear': 'pear',
                'pear-2': 'pear-2',
                'watermelon': 'watermelon',
                'watermelon-2': 'watermelon-2',
                'fruits': 'fruits',
                'fruits-2': 'fruits-2',
                'fruits-3': 'fruits-3',
                'pineapple': 'pineapple',
                'pineapple-2': 'pineapple-2',
                'nut': 'nut',
                'nut-2': 'nut-2',
                'melon': 'melon',
                'melon-2': 'melon-2',
                'windmill': 'windmill',
                'windmill-2': 'windmill-2',
                'tractor': 'tractor',
                'tractor-2': 'tractor-2',
                'beekeeping': 'beekeeping',
                'farmer': 'farmer',
                'farmer-2': 'farmer-2',
                'gardening': 'gardening',
                'bee': 'bee',
                'bee2': 'bee2',
                'honey': 'honey',
                'honey-2': 'honey-2',
                'hatch': 'hatch',
                'eggs': 'eggs',
                'eggs-2': 'eggs-2',
                'eggs-3': 'eggs-3',
                'grape': 'grape',
                'grape-2': 'grape-2',
                'tomateo': 'tomateo',
                'tomateo-2': 'tomateo-2',
                'radish': 'radish',
                'carrot': 'carrot',
                'carrot-2': 'carrot-2',
                'carrot-3': 'carrot-3',
                'eggplant': 'eggplant',
                'eggplant-2': 'eggplant-2',
                'artichoke': 'artichoke',
                'artichoke-2': 'artichoke-2',
                'potato': 'potato',
                'potato-2': 'potato-2',
                'potatoes': 'potatoes',
                'potatoes-2': 'potatoes-2',
                'cabbage': 'cabbage',
                'cabbage-2': 'cabbage-2',
                'capsicum': 'capsicum',
                'capsicum-2': 'capsicum-2',
                'barn': 'barn',
                'barn-2': 'barn-2',
                'farming': 'farming',
                'agrologie': 'agrologie',
                'fertilizer': 'fertilizer',
                'fertilizer-2': 'fertilizer-2',
                'garlic': 'garlic',
                'garlic-2': 'garlic-2',
                'water-droplet': 'water-droplet',
                'water-droplet-2': 'water-droplet-2',
            },
            meat: {
                'meat': 'meat',
                'horse': 'horse',
                'horse-head': 'horse-head',
                'cow-head': 'cow-head',
                'pig-head': 'pig-head',
                'rabbit-head': 'rabbit-head',
                'sheep-head': 'sheep-head',
                'goose-head': 'goose-head',
                'chicken-head': 'chicken-head',
                'chicken': 'chicken',
                'duck-head': 'duck-head',
                'turkey-head': 'turkey-head',
                'fowl-meat-cooked': 'fowl-meat-cooked',
                'meat': 'meat',
                'meat-2': 'meat-2',
                'ribs': 'ribs',
                'meat-porc': 'meat-porc',
                'ribs-2': 'ribs-2',
                'backbone': 'backbone',
                'lungs': 'lungs',
                'lungs-2': 'lungs-2',
                'leather-skin': 'leather-skin',
                'leather-skin-2': 'leather-skin-2',
                'sausage': 'sausage',
                'pig': 'pig',
                'pig-2': 'pig-2',
                'sheep': 'sheep',
                'sheep-2': 'sheep-2',
                'rabbit-2': 'rabbit-2',
                'rabbit': 'rabbit',
                'cow': 'cow',
                'cow-2': 'cow-2',
                'goose': 'goose',
                'goose-2': 'goose-2',
                'fish': 'fish',
                'fish-2': 'fish-2',
            },
            waste: {
                'waste': 'waste',
                'bin-truck': 'bin-truck',
                'bin-recycle': 'bin-recycle',
                'bin-truck-2': 'bin-truck-2',
                'incineration': 'incineration',
                'trash-non-recyclable': 'trash-non-recyclable',
                'trash-recyclable': 'trash-recyclable',
                'trash-bio': 'trash-bio',
                'trash-glass': 'trash-glass',
                'trash-paper': 'trash-paper',
                'trash-cardboard': 'trash-cardboard',
                'bio-waste': 'bio-waste',
                'wood': 'wood',
                'scrap-metal': 'scrap-metal',
                'rubble': 'rubble',
                'placoplatre': 'placoplatre',
                'furniture-waste': 'furniture-waste',
                'electronic-waste': 'electronic-waste',
                'ressource': 'ressource',
                'recycle-paper': 'recycle-paper',
                'recycle-cardboard': 'recycle-cardboard',
                'recycle-plastic': 'recycle-plastic',
                'recycle-aluminum': 'recycle-aluminum',
                'recycle-food-brick': 'recycle-food-brick',
                'recycle-metal': 'recycle-metal',
                'recycle-glass': 'recycle-glass',
                'compost-dock': 'compost-dock',
                'reuse': 'reuse',
                'transit-site': 'transit-site',
                'sorting-center': 'sorting-center',
                'transfer-dock': 'transfer-dock',
                'energy': 'energy',
                'dust-residue': 'dust-residue',
                'clinker': 'clinker',
                'compost': 'compost',
                'recycle-water': 'recycle-water',
                'recycle-electronic': 'recycle-electronic',
                'recycling': 'recycling',
                'cumbersome': 'cumbersome',
                'scrap-metal-2': 'scrap-metal-2',
                'trash-bin': 'trash-bin',
                'trash-bin-2': 'trash-bin-2',
                'recycle-cardboard-2': 'recycle-cardboard-2',
                'recycle-paper-2': 'recycle-paper-2',
                'recycle-glass-2': 'recycle-glass-2',
                'recycle-energy': 'recycle-energy',
                'recycle-gear': 'recycle-gear',
                'industry': 'industry',
                'recycle-aluminum-can': 'recycle-aluminum-can',
                'bio-energy': 'bio-energy',
                'recycle-glass-bottle': 'recycle-glass-bottle',
                'recycle-electronic-2': 'recycle-electronic-2',
                'recycle-fabric': 'recycle-fabric',
            }
        },
    },
    //=======================================================
    //FR
    //=======================================================
    fr: {
        translation: {
            'import': { 'import': 'Icônes importées' },
            agricol: {
                'agricol': 'agricole',
                'pack-of-cereal': 'paquet-de-céréales',
                'apple': 'pomme',
                'apple-2': 'pomme-2',
                'banana': 'banane',
                'banana-2': 'banane-2',
                'berry': 'fraise',
                'berry-2': 'fraise-2',
                'pear': 'poire',
                'pear-2': 'poire-2',
                'watermelon': 'pastèque',
                'watermelon-2': 'pastèque-2',
                'fruits': 'fruits',
                'fruits-2': 'fruits-2',
                'fruits-3': 'fruits-3',
                'pineapple': 'ananas',
                'pineapple-2': 'ananas-2',
                'nut': 'noix',
                'nut-2': 'noix-2',
                'melon': 'melon',
                'melon-2': 'melon-2',
                'windmill': 'moulin-à-vent',
                'windmill-2': 'moulin-à-vent-2',
                'tractor': 'tracteur',
                'tractor-2': 'tracteur-2',
                'beekeeping': 'apiculture',
                'farmer': 'fermier',
                'farmer-2': 'fermier-2',
                'gardening': 'jardinage',
                'bee': 'abeille',
                'bee2': 'abeille-2',
                'honey': 'miel',
                'honey-2': 'miel-2',
                'hatch': 'éclosion',
                'eggs': 'oeufs',
                'eggs-2': 'oeufs-2',
                'eggs-3': 'oeufs-3',
                'grape': 'raisin',
                'grape-2': 'raisin-2',
                'tomateo': 'tomate',
                'tomateo-2': 'tomate-2',
                'radish': 'radis',
                'carrot': 'carotte',
                'carrot-2': 'carotte-2',
                'carrot-3': 'carotte-3',
                'eggplant': 'aubergine',
                'eggplant-2': 'aubergine-2',
                'artichoke': 'artichaut',
                'artichoke-2': 'artichaut-2',
                'potato': 'pomme-de-terre',
                'potato-2': 'pomme-de-terre-2',
                'potatoes': 'pommes-de-terres',
                'potatoes-2': 'pommes-de-terres-2',
                'cabbage': 'chou',
                'cabbage-2': 'chou-2',
                'capsicum': 'poivron',
                'capsicum-2': 'poivron-2',
                'barn': 'grange',
                'barn-2': 'grange-2',
                'farming': 'agricole',
                'agrologie': 'agrologie',
                'fertilizer': 'engrais',
                'fertilizer-2': 'engrais-2',
                'garlic': 'ail',
                'garlic-2': 'ail-2',
                'water-droplet': 'gouttes-eau',
                'water-droplet-2': 'goutte-eau-2',
            },
            meat: {
                'meat': 'viande',
                'horse': 'cheval',
                'horse-head': 'tête-de-cheval',
                'cow-head': 'tête-de-vache',
                'pig-head': 'tête-de cochon',
                'rabbit-head': 'tête-de-lapin',
                'sheep-head': 'tête-de-mouton',
                'goose-head': 'tête-oie',
                'chicken-head': 'tête-de-poule',
                'chicken': 'poulet',
                'duck-head': 'tête-de-canard',
                'turkey-head': 'tête-de-dinde',
                'fowl-meat-cooked': 'cuit-à-la-volaille',
                'meat': 'viande',
                'meat-2': 'viande-2',
                'ribs': 'côtes',
                'meat-porc': 'viande-porc',
                'ribs-2': 'côtes-2',
                'backbone': 'colone-vertebrale',
                'lungs': 'poumons',
                'lungs-2': 'poumons-2',
                'leather-skin': 'cuir-peau',
                'leather-skin-2': 'cuir-peau-2',
                'sausage': 'saucisse',
                'pig': 'cochon',
                'pig-2': 'cochon-2',
                'sheep': 'mouton',
                'sheep-2': 'mouton-2',
                'rabbit-2': 'lapin-2',
                'rabbit': 'lapin',
                'cow': 'vache',
                'cow-2': 'vache-2',
                'goose': 'oie',
                'goose-2': 'oie-2',
                'fish': 'poisson',
                'fish-2': 'poisson-2',
            },
            waste: {
                'waste': 'déchet',
                'bin-truck': 'camion-poubelle',
                'bin-recycle': 'poubelle-recyclage',
                'bin-truck-2': 'camion-poubelle-2',
                'incineration': 'incinération',
                'trash-non-recyclable': 'déchets-non-recyclable',
                'trash-recyclable': 'déchets-recyclable',
                'trash-bio': 'déchets-bio',
                'trash-glass': 'déchets-verre',
                'trash-paper': 'déchets-papier',
                'trash-cardboard': 'déchets-carton',
                'bio-waste': 'biodéchets',
                'wood': 'bois',
                'scrap-metal': 'ferraille',
                'rubble': 'décombre',
                'placoplatre': 'placoplatre',
                'furniture-waste': 'gaspillage-de-meubles',
                'electronic-waste': 'déchets-électroniques',
                'ressource': 'ressource',
                'recycle-paper': 'papier-recyclé',
                'recycle-cardboard': 'carton recyclé',
                'recycle-plastic': 'recyclage-plastique',
                'recycle-aluminum': 'recyclage-aluminium',
                'recycle-food-brick': 'recyclage-food-brick',
                'recycle-metal': 'métal recyclé',
                'recycle-glass': 'verre recyclé',
                'compost-dock': 'station-de-compostage',
                'reuse': 'réutilisation',
                'transit-site': 'site-de-transit',
                'sorting-center': 'centre-de-tri',
                'transfer-dock': 'centre-de-transfert',
                'energy': 'énergie',
                'dust-residue': 'poussière-résidu',
                'clinker': 'clinker',
                'compost': 'compost',
                'recycle-water': 'eau-recyclée',
                'recycle-electronic': 'recyclage-électronique',
                'recycling': 'recyclage',
                'cumbersome': 'encombrant',
                'scrap-metal-2': 'ferraille-2',
                'trash-bin': 'poubelle-déchets',
                'trash-bin-2': 'poubelle-déchets-2',
                'recycle-cardboard-2': 'recyclage-carton-2',
                'recycle-paper-2': 'recyclage-papier-2',
                'recycle-glass-2': 'recyclage-verre-2',
                'recycle-energy': 'recyclage-énergie',
                'recycle-gear': 'équipement-de-recyclage',
                'industry': 'industrie',
                'recycle-aluminum-can': 'recyclage-cannette-aluminium',
                'bio-energy': 'bioénergie',
                'recycle-glass-bottle': 'recyclage-bouteille-verre',
                'recycle-electronic-2': 'recyclage-électronique-2',
                'recycle-fabric': 'recyclage-tissue',
            }
        }
    }
};
